import React, { memo } from 'react'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'

import CustomAlert from '../shared/customAlert/CustomAlert'
import { TRANSACTIONS_URL } from '../../constants/navigation'
import { formatTicks } from '../../util/string.helpers'
import {
  pointsConversionRate,
  pointsToCryptoConversion
} from '../../util/component.helpers'
import { selectExchangeRate } from '../../util/pointsExchange.helpers'
import AnimateRewards from '../shared/animateRewards/AnimateRewards'

const ExchangeAlert = ({
  t,
  isError,
  onClose,
  symbol,
  offramp,
  targetSymbol,
  reward,
  provider,
  cryptoExchanges
}) => {
  return isError ? (
    <CustomAlert
      severity='error'
      title={t('shop.failed-exchange')}
      desc={t('exchange.receive-exchange-failed')}
      onClose={onClose}
    />
  ) : (
    <>
      <CustomAlert
        severity='success'
        title={t('shop.success-exchange')}
        desc={
          <>
            <Trans
              i18nKey='shop.exchange-success-desc'
              values={{
                symbol,
                targetSymbol,
                value: formatTicks(
                  provider?.isCrypto
                    ? pointsToCryptoConversion(
                        reward,
                        offramp,
                        selectExchangeRate(cryptoExchanges, provider)
                      )
                    : pointsConversionRate(reward, provider)
                )
              }}
            >
              <Link to={TRANSACTIONS_URL} style={{ color: 'inherit' }} />
            </Trans>
            <AnimateRewards />
          </>
        }
        onClose={onClose}
      />
    </>
  )
}

export default memo(ExchangeAlert)
